import * as React from 'react';
import { LocationCardProps } from './LocationCardWrapper';
import { LocationPersonaControl } from './LocationPersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';

let styles = require('./LocationCard.scss');

export default class LocationCompactCard extends React.Component<LocationCardProps, any> {
    render() {
        return (
            <LocationPersonaControl
                className={styles.persona}
                showPersonaDetails={true}
                size={PersonaSize.large}
                locationPersona={this.props.locationPersona}
            />
        );
    }
}
